enum PaymentMethodTypes {
  DEBIT = 'DEBIT',
  RCC = 'RCC',
  MAIL = 'MAIL',
  MAIL_PROVIDER = 'MAIL_PROVIDER'
}

export default PaymentMethodTypes;
